import { useMutation } from "@apollo/client/react";
import { REJECT_INVOICE_UPLOAD_DOCUMENT } from "../../mutations/documentHandler/rejectInvoiceUploadDocument";
import GET_ALL_UPLOAD_UNITS from "../../queries/documentHandler/getAllUploadUnits";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";

export const useRejectInvoiceUploadDocument = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: () => void;
}) => {
  const [rejectUploadDocument, { data, loading, error }] = useMutation(
    REJECT_INVOICE_UPLOAD_DOCUMENT,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_ALL_UPLOAD_UNITS, GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    },
  );

  return { rejectUploadDocument, data, loading, error };
};
